import React, { forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import CodeActions from '../CodeActions';
import style from './HtmlPageSection.module.less';
import ButtonConfigurator from '../ButtonConfigurator';
import SdkConfigurator from '../SdkConfigurator';
import SectionToggle from '../SectionToggle';
import OrderConfigurator from '../OrderConfigurator';
import OrderActions from '../OrderActions';
import CardConfigurator from '../CardConfigurator';
import TypeConfigurator from '../TypeConfigurator';
import ThreeDsConfigurator from '../ThreeDsConfigurator';
import FundingConfigurator from '../FundingConfigurator';
import PaymentTokens from '../PaymentTokens';
import VaultSetupTokenConfigurator from '../VaultSetupTokenConfigurator';
import ShippingCallbackConfigurator from '../ShippingCallbackConfigurator';
import ContactModule from '../ContactModule';
import GeoLocOverride from '../GeoLocOverride';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';

const ComponentMap = {
  CodeActions,
  ButtonConfigurator,
  SdkConfigurator,
  OrderConfigurator,
  OrderActions,
  CardConfigurator,
  TypeConfigurator,
  ThreeDsConfigurator,
  FundingConfigurator,
  PaymentTokens,
  VaultSetupTokenConfigurator,
  ShippingCallbackConfigurator,
  ContactModule,
  GeoLocOverride
};

const HtmlPageSection = forwardRef(({ ecmContent, highlighted, onClick }, ref) => {
  const content = ecmContent || {};
  const {
    code: { status }
  } = useContext(IntegrationPageSectionContext);
  const { contentDetails, contentJson, codeBlockKey } = content;
  if (!content || (!contentDetails && !contentJson)) return <></>;

  const isSectionToggleActive = codeBlockKey?.split(',').some((key) => !!status[key]) ?? false;

  return (
    <div
      ref={ref}
      data-tag={content.key}
      className={cx(style.base, {
        [style.highlighted_section]: highlighted
      })}
      onClick={() => {
        if (onClick && typeof onClick === 'function') onClick(content.key);
      }}
      onKeyDown={() => {
        if (onClick && typeof onClick === 'function') onClick(content.key);
      }}
      role="button"
      tabIndex={0}
    >
      <div className={style.step_content_section}>
        <div
          dangerouslySetInnerHTML={{
            __html: contentDetails
          }}
        />
        {contentJson?.CodeBlockToggle && (
          <SectionToggle
            contentKey={codeBlockKey}
            sectionKey={content.key}
            label={contentJson.CodeBlockToggle.label}
            title={contentJson.CodeBlockToggle.title}
            checked={!!contentJson.CodeBlockToggle?.checked || isSectionToggleActive}
            selectable={contentJson.CodeBlockToggle?.selectable}
          />
        )}
      </div>
      <div>
        {contentJson &&
          Object.keys(contentJson).map((componentKey) => {
            const Component = ComponentMap[componentKey];
            const componentContent = contentJson[componentKey];
            if (Component) {
              return (
                <Component
                  key={componentKey}
                  content={componentContent}
                  codeBlockKey={codeBlockKey}
                />
              );
            }
            return <></>;
          })}
      </div>
    </div>
  );
});
export default HtmlPageSection;

HtmlPageSection.propTypes = {
  ecmContent: PropTypes.object,
  highlighted: PropTypes.bool,
  onClick: PropTypes.func
};
HtmlPageSection.defaultProps = { ecmContent: null, highlighted: false, onClick: undefined };
HtmlPageSection.displayName = 'HtmlPageSection';
